module.exports = {
  messages: {
    ADVERTISING_DIGITAL_SERVICE_ACT_HEADLINE: 'Warum siehst Du diese Anzeige?',
    ADVERTISING_DIGITAL_SERVICE_ACT_POP_UP_FOOTER_CTA: 'Erfahre hier mehr',
    ADVERTISING_DIGITAL_SERVICE_ACT_POP_UP_FOOTER_MESSAGE:
      'über mögliche Zielgruppen-Kriterien.',
    ADVERTISING_DIGITAL_SERVICE_ACT_POP_UP_MESSAGE:
      'Du siehst diese Anzeige, weil Du eines oder mehrere der Targeting-Kriterien des Werbetreibenden erfüllst.',
    ADVERTISING_LEAD_AD_FORM_CHECKBOX_ERROR:
      'Bitte das Häkchen setzen, um fortzufahren',
    ASK_XING_NEW: 'Neu',
    ASK_XING_TITLE: 'Frag XING',
    BOTTOM_BAR_FIND_JOBS_LABEL: 'Jobs finden',
    BOTTOM_BAR_INSIGHTS_LABEL: 'Insights',
    BOTTOM_BAR_NETWORK_LABEL: 'Netzwerk',
    BOTTOM_BAR_NOTIFICATIONS_LABEL: 'Mitteilungen',
    BOTTOM_BAR_YOUR_JOBS_LABEL: 'Deine Jobs',
    BUTTON_CLOSEWINDOW: 'Fenster schließen',
    COMPANY_DIRECTORY_LIST_H: 'Unternehmen nach Anfangsbuchstaben',
    COMPANY_DIRECTORY_OTHERS: 'Weitere',
    DISCIPLINE_1001: 'Analyse und Statistik',
    DISCIPLINE_1002: 'Administration, Sachbearbeitung und Verwaltung',
    DISCIPLINE_1003: 'Beratung / Consulting',
    DISCIPLINE_1004: 'Kundenbetreuung',
    DISCIPLINE_1005: 'Einkauf, Materialwirtschaft und Logistik',
    DISCIPLINE_1006: 'Finanzen, Rechnungswesen und Controlling',
    DISCIPLINE_1007: 'Forschung, Lehre und Entwicklung',
    DISCIPLINE_1008: 'Gesundheit, Medizin und Soziales',
    DISCIPLINE_1009: 'Grafik, Design und Architektur',
    DISCIPLINE_1010: 'Ingenieurwesen und technische Berufe',
    DISCIPLINE_1011: 'IT und Softwareentwicklung',
    DISCIPLINE_1012: 'Management und Unternehmensentwicklung',
    DISCIPLINE_1013: 'Marketing und Werbung',
    DISCIPLINE_1014: 'Personalwesen und HR',
    DISCIPLINE_1015: 'PR, Öffentlichkeitsarbeit und Journalismus',
    DISCIPLINE_1016: 'Produktion und Handwerk',
    DISCIPLINE_1017: 'Produktmanagement',
    DISCIPLINE_1018: 'Projektmanagement',
    DISCIPLINE_1019: 'Prozessplanung und Qualitätssicherung',
    DISCIPLINE_1020: 'Recht',
    DISCIPLINE_1021: 'Vertrieb und Handel',
    DISCIPLINE_1022: 'Sonstige Tätigkeitsfelder',
    'DISCO_OBJECTS_FOLLOWER.one': 'Follower',
    'DISCO_OBJECTS_FOLLOWER.other': 'Follower',
    'DISCO_OBJECTS_FOLLOWER.zero': 'Follower',
    EMPLOYMENT_TYPE_CONTRACTOR: 'Selbstständig',
    EMPLOYMENT_TYPE_CONTRACTOR_LOCAL_SERPS: 'Freelancer',
    EMPLOYMENT_TYPE_FULL_TIME: 'Vollzeit',
    EMPLOYMENT_TYPE_INTERN: 'Studierende',
    EMPLOYMENT_TYPE_PART_TIME: 'Teilzeit',
    EMPLOYMENT_TYPE_SEASONAL: 'Saisonarbeit',
    EMPLOYMENT_TYPE_STUDENT_LOCAL_SERPS: 'Studentenjobs',
    EMPLOYMENT_TYPE_TEMPORARY: 'Aushilfe',
    EMPLOYMENT_TYPE_TEMPORARY_LOCAL_SERPS: 'Mini',
    EMPLOYMENT_TYPE_VOLUNTARY: 'Ehrenamt',
    FRAME_HEADER_SEARCH: 'Suche',
    JOB_SEARCH_BOOST_ME_UP_CTA: 'Jetzt Profil boosten',
    JOB_SEARCH_BOOST_ME_UP_HEADLINE: 'Booster für Dein Profil?',
    JOB_SEARCH_BOOST_ME_UP_PARAGRAPH:
      'Platziere Dein Profil genau da, wo’s sein soll: im Fokus passender Recruiter·innen.',
    JOB_SEARCH_BOOST_ME_UP_SENTENCE:
      'Hol Dir kostenlos eine 14-tägige Top-Platzierung!',
    JOB_SEARCH_PROJOBS_UPSELL_CTA: 'Hol Dir ProJobs',
    JOB_SEARCH_PROJOBS_UPSELL_HEADLINE:
      'Werd jetzt selbst zum Suchergebnis von Recruiter·innen.',
    JOB_SEARCH_PROJOBS_UPSELL_RECRUITER_BASIC_MESSAGES_FACTOR: '10×',
    JOB_SEARCH_PROJOBS_UPSELL_RECRUITER_BASIC_VISITS_FACTOR: '15×',
    JOB_SEARCH_PROJOBS_UPSELL_RECRUITER_MESSAGES_FACTOR: '2×',
    JOB_SEARCH_PROJOBS_UPSELL_RECRUITER_MESSAGES_TEXT: 'mehr Nachrichten',
    JOB_SEARCH_PROJOBS_UPSELL_RECRUITER_VISITS_FACTOR: '2,5×',
    JOB_SEARCH_PROJOBS_UPSELL_RECRUITER_VISITS_TEXT: 'mehr Besuche',
    JOB_SEO_CATEGORY_JOBS: '{category} Jobs',
    JOB_SEO_CITY_JOBS: 'Jobs in {city}',
    JOB_SEO_COMPANY_JOBS: '{term} Jobs',
    JOB_SEO_EMPLOYMENT_TYPE_: 'Ehrenamt-Jobs',
    JOB_SEO_EMPLOYMENT_TYPE_CONTRACTOR: 'Freelancer-Jobs',
    JOB_SEO_EMPLOYMENT_TYPE_FULL_TIME: 'Vollzeit-Jobs',
    JOB_SEO_EMPLOYMENT_TYPE_INTERN: 'Studierende-Jobs',
    JOB_SEO_EMPLOYMENT_TYPE_PART_TIME: 'Teilzeit-Jobs',
    JOB_SEO_EMPLOYMENT_TYPE_SEASONAL: 'Saisonarbeit-Jobs',
    JOB_SEO_EMPLOYMENT_TYPE_TEMPORARY: 'Aushilfe-Jobs',
    JOB_SEO_JOB_TYPE_CONTRACTOR_JOBS:
      'Finde jetzt Aufträge und Projekte für Freiberufler.',
    JOB_SEO_JOB_TYPE_FULL_TIME_JOBS: 'Finde jetzt Deine neue Vollzeitstelle.',
    JOB_SEO_JOB_TYPE_INTERN_JOBS: 'Finde jetzt das ideale Praktikum.',
    JOB_SEO_JOB_TYPE_PART_TIME_JOBS: 'Finde jetzt Deine neue Teilzeitstelle.',
    JOB_SEO_JOB_TYPE_SEASONAL_JOBS: 'Finde jetzt Deine nächste Saisonarbeit.',
    JOB_SEO_JOB_TYPE_TEMPORARY_JOBS:
      'Finde jetzt Deine nächste Aushilfestelle.',
    JOB_SEO_JOB_TYPE_VOLUNTARY_JOBS: 'Finde jetzt ein Ehrenamt.',
    JOB_SEO_SERPS_EMPTY_SEARCH: 'Keine Ergebnisse für {keyword}',
    JOB_SEO_TERM_JOBS: '{term} Jobs',
    JOBS_CREATE_SEARCH_ALERT: 'Suchauftrag erstellen',
    JOBS_FIND_JOBS_SEARCH_BUTTON: 'Jobs finden',
    JOBS_FIND_JOBS_SEARCH_LOCATION_PLACEHOLDER: 'Standort',
    JOBS_FIND_JOBS_SEARCH_PLACEHOLDER: 'Job-Titel eingeben',
    JOBS_FIND_JOBS_SEARCH_RADIUS_PLACEHOLDER: 'Umkreis',
    JOBS_FIND_JOBS_TITLE: 'Jobs finden',
    JOBS_JOB_TEASER_SAVE: 'Job merken',
    JOBS_JOB_TEASER_SAVED: 'Gemerkt',
    JOBS_MYJOBS_SEARCH_ALERTS_SECTION_TITLE: 'Deine Suchaufträge',
    JOBS_RECENT_SEARCH_EMPTY: 'Alle Jobs',
    JOBS_SEARCH_AI_BACK_TO_CLASSIC: 'Zurück zur Standard-Suche',
    JOBS_SEARCH_AI_EMPTY_STATE_BANNER_SUBTITLE:
      "Versuch's noch mal mit einem anderen Text. Oder setz ein paar Filter zurück.",
    JOBS_SEARCH_AI_ENTRYPOINT_BANNER: 'Neu: Finde Deinen Job mit KI',
    JOBS_SEARCH_AI_ENTRYPOINT_FLAG_DESKTOP: 'Jetzt testen',
    JOBS_SEARCH_AI_ENTRYPOINT_FLAG_MOBILE: 'Jetzt testen',
    JOBS_SEARCH_AI_FEEDBACK_BAD_BUTTON: 'Zur Umfrage',
    JOBS_SEARCH_AI_FEEDBACK_BAD_COPY:
      'Nicht zufrieden? Hilf uns gern, die KI zu verbessern.',
    JOBS_SEARCH_AI_FEEDBACK_DISLIKE_A11Y_LABEL: 'Unbefriedigend',
    JOBS_SEARCH_AI_FEEDBACK_HEADLINE:
      'Wie bewertest Du die Qualität der Ergebnisse?',
    JOBS_SEARCH_AI_FEEDBACK_LIKE_A11Y_LABEL: 'Gut',
    JOBS_SEARCH_AI_FEEDBACK_MR_BUTTON: 'Mitmachen & verbessern',
    JOBS_SEARCH_AI_FEEDBACK_MR_SUBTITLE:
      'Du gestaltest mit: Dein Feedback hilft Dir und anderen.',
    JOBS_SEARCH_AI_FEEDBACK_MR_TITLE:
      'Wie findest Du die neue Jobsuche mit KI?',
    JOBS_SEARCH_AI_FEEDBACK_NEUTRAL_A11Y_LABEL: 'In Ordnung',
    JOBS_SEARCH_AI_FEEDBACK_THANKS:
      'Danke für Dein Feedback. Das hilft uns, besser zu werden.',
    JOBS_SEARCH_AI_FILTERS_SHOW_RESULTS_BUTTON: 'Jobs anzeigen',
    JOBS_SEARCH_AI_FLAG: 'Jetzt mit KI',
    JOBS_SEARCH_AI_HEADLINE: 'Eine neue Art der Job-Suche',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_1: 'Beschreib mal Deinen Traumjob …',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_10:
      'Erzähl auch von Deinen Erfahrungen und Fähigkeiten …',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_2:
      'Schreib einfach in ganz natürlicher Sprache …',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_3: 'Jobs, die Du gern machen würdest …',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_4:
      'Deine Ideen für Deinen nächsten Karriere-Schritt …',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_5:
      'Job-Titel, Karriere-Stufe, Wunsch-Gehalt, …',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_6:
      'Alles, was Dir im Job-Leben wichtig ist …',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_7: 'Je konkreter, desto besser …',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_8:
      'Teilzeit oder Vollzeit, Büro oder Home-Office, …',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_9:
      'Lieber einfache Sätze statt viele Schlagwörter …',
    JOBS_SEARCH_AI_LOADING_SUGGESTION: 'Wir schauen uns Dein Profil an ...',
    JOBS_SEARCH_AI_NO_RESULTS_HEADLINE: 'Keine passenden Jobs gefunden',
    JOBS_SEARCH_AI_PLACEHOLDER_1:
      'Beschreib mal Deinen Traum-Job. Leg einfach los …',
    JOBS_SEARCH_AI_PLACEHOLDER_2:
      'Jedes Wort, jede Zahl, jede Info hilft für bessere Ergebnisse …',
    JOBS_SEARCH_AI_PLACEHOLDER_3:
      'Job-Titel, Karriere-Stufe, Wunsch-Branche, …',
    JOBS_SEARCH_AI_PLACEHOLDER_4:
      'Teilzeit oder Vollzeit? Büro oder Home-Office?',
    JOBS_SEARCH_AI_PLACEHOLDER_5: 'Nenn auch Deine Stärken und Fähigkeiten …',
    JOBS_SEARCH_AI_PLACEHOLDER_6: 'Und verrate, was Du verdienen willst …',
    JOBS_SEARCH_AI_PLACEHOLDER_7:
      'Probier einfach ein bisschen rum und spiel mit dem Text …',
    JOBS_SEARCH_AI_RESULTS_HEADLINE: 'Passende Jobs für Deine Suche',
    JOBS_SEARCH_AI_SUGGESTION_ERROR:
      'Tipp: Aktualisier Profil und Job-Wünsche für eine detailliertere Suche mit der XING KI. Oder tipp einfach selbst ein, wonach Du suchst.',
    JOBS_SEARCH_AI_SUGGESTION_SERVER_ERROR:
      'Das hat leider nicht geklappt. Versuch’s bitte gleich nochmal.',
    JOBS_SEARCH_AI_SWIMP_SUGGESTION: 'Such mit meinem Profil',
    JOBS_SEARCH_AI_SWIMP_SUGGESTION_SUBTITLE:
      'Die XING KI findet Deinen nächsten Job',
    JOBS_SEARCH_AI_SWIMS_SUGGESTION: 'Unterstütz mich beim Quereinstieg',
    JOBS_SEARCH_AI_SWIMS_SUGGESTION_SUBTITLE:
      'Die XING KI zeigt Dir, was alles möglich ist.',
    JOBS_SEARCH_ALERT_CREATED: 'Suchauftrag erstellt',
    JOBS_SEARCH_APPLIED_FILTERS_GROUP_A11Y: 'Aktive Filter',
    JOBS_SEARCH_BUTTON_BACK: 'Zurück',
    JOBS_SEARCH_COMPANY_CULTURE_FILTER_VALUE: 'Kultur passt',
    JOBS_SEARCH_EDIT_ALERT_SAVE_BUTTON: 'Änderungen speichern',
    JOBS_SEARCH_EMPTY_ERROR_HEADLINE:
      'Gib hier einen Job-Titel oder Standort ein.',
    JOBS_SEARCH_EMPTY_ERROR_TEXT: 'Dann suchen wir Deine Matches heraus.',
    JOBS_SEARCH_EMPTY_STATE_BANNER_SEARCH_ALERT_EDIT_SUBTITLE:
      'Probier mal andere Filter, z. B. einen größeren Suchgebiet oder andere Suchbegriffe. Du kannst den Suchauftrag auch so speichern und aufs Match warten.',
    JOBS_SEARCH_EMPTY_STATE_BANNER_SEARCH_ALERT_SUBTITLE:
      'Ändere Deine Filter z. B. mit einem größeren Radius oder verwende andere Suchbegriffe.',
    JOBS_SEARCH_EMPTY_STATE_BANNER_SUBTITLE:
      'Ändere Deine Filter z. B. mit einem größeren Radius, verwende andere Suchbegriffe oder erstell einen Suchauftrag.',
    JOBS_SEARCH_EMPTY_STATE_NO_RESULTS_FOR_LABEL: 'für',
    JOBS_SEARCH_EMPTY_STATE_NO_RESULTS_TITLE: 'Keine Ergebnisse',
    JOBS_SEARCH_EMPTY_STATE_RECOMMENDATIONS_HEADLINE:
      'Jobs, die Dich auch interessieren könnten:',
    'JOBS_SEARCH_EMPTY_STATE_WIDER_RESULTS_HEADER.one':
      'Wir haben einen passenden Job in einer anderen Stadt gefunden:',
    'JOBS_SEARCH_EMPTY_STATE_WIDER_RESULTS_HEADER.other':
      'Wir haben {variable_2} passende Jobs in einer anderen Stadt gefunden:',
    JOBS_SEARCH_FILTER_CAREER_LEVEL: 'Karriere-Stufe',
    JOBS_SEARCH_FILTER_CITY: 'Ort',
    JOBS_SEARCH_FILTER_COUNTRY: 'Land',
    JOBS_SEARCH_FILTER_DISCIPLINE: 'Tätigkeitsfeld',
    JOBS_SEARCH_FILTER_EMPLOYEE_PERKS: 'Besondere Vorzüge',
    JOBS_SEARCH_FILTER_EMPLOYMENT_TYPE: 'Beschäftigungsart',
    JOBS_SEARCH_FILTER_INDUSTRY: 'Branche',
    JOBS_SEARCH_FILTER_LOCATION_TEXT: 'Standort:',
    JOBS_SEARCH_FILTER_RADIUS: 'Suchgebiet',
    JOBS_SEARCH_FILTER_RADIUS_SLIDER_TEXT_WEB: 'Nur in {location}',
    JOBS_SEARCH_FILTER_REMOTE_OPTION: 'Arbeitsplatz',
    JOBS_SEARCH_FILTER_SALARY: 'Gehalt',
    JOBS_SEARCH_FILTER_SALARY_MAX_SLIDER_A11Y: 'Maximalgehalt',
    JOBS_SEARCH_FILTER_SALARY_MIN_SLIDER_A11Y: 'Mindestgehalt',
    JOBS_SEARCH_FILTER_SINCE_EMPTY_STATE_BUTTON: 'Jobs sehen',
    JOBS_SEARCH_FILTER_SINCE_EMPTY_STATE_HEADLINE:
      'Momentan keine neuen Jobs für Dich',
    JOBS_SEARCH_FILTER_SINCE_EMPTY_STATE_SUBHEADLINE:
      'Sieh Dir andere Jobs aus dieser Suche an.',
    JOBS_SEARCH_FILTER_SINCE_VALUE: 'Neue Jobs',
    JOBS_SEARCH_FILTER_TIME_FRAME: 'Veröffentlicht',
    JOBS_SEARCH_FILTER_TIME_FRAME_LAST_24_HOURS: 'in den letzten 24 Stunden',
    JOBS_SEARCH_FILTER_TIME_FRAME_LAST_MONTH: 'im letzten Monat',
    JOBS_SEARCH_FILTER_TIME_FRAME_LAST_WEEK: 'in der letzten Woche',
    JOBS_SEARCH_FILTER_WORKING_ATMOSPHERE: 'Arbeitskultur',
    JOBS_SEARCH_FILTERS_ALL_HEADER: 'Filter',
    JOBS_SEARCH_FILTERS_SHOW_ALL: 'Alle anzeigen',
    JOBS_SEARCH_FILTERS_SHOW_LESS: 'Weniger anzeigen',
    JOBS_SEARCH_FILTERS_SHOW_MORE: 'Mehr anzeigen',
    'JOBS_SEARCH_FILTERS_SHOW_RESULTS_BUTTON.one': 'Einen Job anzeigen',
    'JOBS_SEARCH_FILTERS_SHOW_RESULTS_BUTTON.other':
      '{variable_2} Jobs anzeigen',
    'JOBS_SEARCH_FILTERS_SHOW_RESULTS_BUTTON.zero': 'Keine Treffer',
    'JOBS_SEARCH_HEADLINE.one': 'Einen Job gefunden',
    'JOBS_SEARCH_HEADLINE.other': '{variable_2} Jobs gefunden',
    'JOBS_SEARCH_HEADLINE.zero': 'Keine Ergebnisse',
    JOBS_SEARCH_LOCATION_NO_RADIUS: 'Kein Umkreis',
    JOBS_SEARCH_PAGINATION_LOAD_MORE: 'Mehr anzeigen',
    JOBS_SEARCH_PAGINATION_TEXT: '{results} von {total} Ergebnissen',
    JOBS_SEARCH_RESET_FILTERS_BUTTON: 'Filter entfernen',
    JOBS_SEARCH_SORT_ORDER_NEWEST: 'Neueste zuerst',
    JOBS_SEARCH_SORT_ORDER_RELEVANCE: 'Relevanteste zuerst',
    JOBS_SEARCH_SORT_ORDER_TOP_RATED: 'Top-Bewertungen zuerst',
    JOBS_SEARCH_SORT_TITLE: 'Sortierung',
    MEMENU_FOLLOWING_LABEL: 'Folgst Du',
    MEMENU_HELP_LABEL: 'Hilfe',
    MEMENU_JOB_ADS_LABEL: 'Stellenanzeigen verwalten',
    MEMENU_JOB_PREFERENCES_LABEL: 'Job-Wünsche',
    MEMENU_MY_POSTS_LABEL: 'Deine Beiträge',
    MEMENU_PREMIUM_FOR_BASIC_USER_LABEL: 'Premium werden',
    MEMENU_PREMIUM_LABEL: 'Premium',
    MEMENU_PROBUSINESS_LABEL: 'ProBusiness',
    MEMENU_PROFILE_LABEL: 'Profil',
    MEMENU_PROJOBS_FOR_BASIC_USER_LABEL: 'ProJobs werden',
    MEMENU_PROJOBS_LABEL: 'ProJobs',
    MEMENU_SETTINGS_LABEL: 'Einstellungen',
    MP_000_RESOURCE_JOB_TYPES_TEMPORARY: 'Minijobs',
    NATIVE_ADS_DOT_MENU_REPORT_OBJECT: 'Anzeige melden',
    NATIVE_ADS_LEARN_MORE_BUTTON: 'Mehr erfahren',
    NATIVE_ADS_SPONSORED_LABEL: 'Gesponsert',
    SEARCH_DROPDOWN_COMPANIES: 'Unternehmen',
    SEARCH_DROPDOWN_JOBS: 'Jobs',
    SEARCH_DROPDOWN_MEMBERS: 'Mitglieder',
    SEARCH_DROPDOWN_NEWS: 'News',
    VERTICAL_NAV_BUSINESS_SOLUTIONS_LABEL: 'Business-Lösungen',
    VERTICAL_NAV_BUSINESS_SOLUTIONS_SHORT_LABEL: 'Business',
    VERTICAL_NAV_FIND_JOBS_LABEL: 'Jobs finden',
    VERTICAL_NAV_FOLLOWING_LABEL: 'Folgst Du',
    VERTICAL_NAV_INSIGHTS_LABEL: 'Insights',
    VERTICAL_NAV_JOB_PREFERENCES_LABEL: 'Job-Wünsche',
    VERTICAL_NAV_MESSAGES_LABEL: 'Nachrichten',
    VERTICAL_NAV_MY_POSTS_LABEL: 'Deine Beiträge',
    VERTICAL_NAV_NETWORK_LABEL: 'Netzwerk',
    VERTICAL_NAV_NETWORK_SHORT_LABEL: 'Netzwerk',
    VERTICAL_NAV_PREMIUM_FOR_BASIC_USER_LABEL: 'Premium werden',
    VERTICAL_NAV_PREMIUM_LABEL: 'Premium',
    VERTICAL_NAV_PREMIUM_SHORT_LABEL: 'Premium',
    VERTICAL_NAV_PROBUSINESS_LABEL: 'ProBusiness',
    VERTICAL_NAV_PROFILE_LABEL: 'Profil',
    VERTICAL_NAV_PROJOBS_FOR_BASIC_USER_LABEL: 'ProJobs werden',
    VERTICAL_NAV_PROJOBS_LABEL: 'ProJobs',
    VERTICAL_NAV_YOUR_JOBS_LABEL: 'Deine Jobs',
    XAM_GENERIC_ERROR_MESSAGE:
      "Das hat leider nicht geklappt. Versuchen Sie's bitte noch mal.",
    XAM_LEAD_AD_CUSTOM_QUESTION_PLACEHOLDER: 'Geben Sie hier Ihre Antwort ein.',
    XAM_LEAD_AD_FORM_THANKS_CTA_DOWNLOAD_NOW: 'Jetzt herunterladen',
    XAM_LEAD_AD_FORM_THANKS_CTA_TRY_NOW: 'Jetzt ausprobieren',
    XAM_LEAD_AD_FORM_THANKS_CTA_VISIT_COMPANY_WEBSITE:
      'Zur Unternehmenswebsite',
    XAM_LEAD_AD_FORM_THANKS_CTA_VISIT_NOW: 'Jetzt besuchen',
    XAM_LEAD_AD_FORM_THANKS_CTA_VISIT_XING_PAGE: 'Zur XING Seite',
    XAM_LEAD_AD_PREVIEW_CONFIRMATION_SUCCESS_MESSAGE: 'Anfrage gesendet',
    XAS_ARMSTRONG_LEAD_AD_FORM_THANKS_BUTTON_COPY: 'XING Seite ansehen',
    XDS_BACK_TO_TOP_BUTTON: 'Nach oben',
    XDS_DISCOVER_BADGE_A11Y: 'Neue Funktion',
    XDS_EMPTYSTATE_ERROR_BUTTON: 'Noch mal versuchen',
    XDS_EMPTYSTATE_ERROR_DESCRIPTION: "Bitte versuch's noch mal.",
    XDS_EMPTYSTATE_ERROR_TITLE: 'Das hat leider nicht geklappt.',
    XDS_MINI_BADGE_A11Y: 'Neue Benachrichtigung',
    'XDS_NOTIFICATION_BADGE_GENERIC_A11Y.one': 'Eine neue Benachrichtigung',
    'XDS_NOTIFICATION_BADGE_GENERIC_A11Y.other':
      '{value} neue Benachrichtigungen',
    XDS_SKELETON_GENERIC_A11Y: 'Wird geladen',
    XJM_BREADCRUMB_HOME: 'Jobbörse',
    XJM_JOBS_SEO_ROLE_FAQ_HEADLINE: 'Häufig gestellte Fragen',
    XJM_JOBS_SEO_ROLE_FAQ_TOP_CITY_ANSWER:
      'Die beliebteste Stadt für {jobRole} ist {firstCity}.',
    XJM_JOBS_SEO_ROLE_FAQ_TOP_CITY_QUESTION:
      'Wo gibt es am meisten offene Stellen für {jobRole}?',
    XJM_JOBS_SEO_ROLE_FAQ_TOP_SKILL_ANSWER:
      'Für einen Job als {jobRole} ist vor allem {firstSkill} von Vorteil.',
    XJM_JOBS_SEO_ROLE_FAQ_TOP_SKILL_QUESTION:
      'Welche Fähigkeiten braucht man als {jobRole}?',
    XJM_JOBS_SEO_ROLE_FAQ_TOP_THREE_CITIES_ANSWER:
      'Die beliebtesten Städte für {jobRole} sind {firstCity}, {secondCity}, und {thirdCity}.',
    XJM_JOBS_SEO_ROLE_FAQ_TOP_THREE_SKILLS_ANSWER:
      'Für einen Job als {jobRole} sind vor allem {firstSkill}, {secondSkill} und {thirdSkill} von Vorteil.',
    XJM_JOBS_SEO_ROLE_FAQ_TOP_TWO_CITIES_ANSWER:
      'Die beliebtesten Städte für {jobRole} sind {firstCity} und {secondCity}.',
    XJM_JOBS_SEO_ROLE_FAQ_TOP_TWO_SKILLS_ANSWER:
      'Für einen Job als {jobRole} sind vor allem {firstSkill} und {secondSkill} von Vorteil. ',
    XJM_JOBS_SEO_ROLE_RELATED_JOBS_HEADLINE: 'Verwandte Jobs',
    XJM_JOBS_SEO_ROLE_SALARY_DESCRIPTION:
      'Der Großteil der als {jobRole} Beschäftigten verdienen in Deutschland zwischen {minimumSalary} und {maximumSalary} wobei der Durchschnitt bei {averageSalary}€ liegt. ',
    XJM_JOBS_SEO_ROLE_SALARY_HEADER: 'Was verdient man als {jobRole}?',
    XJM_JOBS_SEO_ROLE_SALARY_LABEL: 'Durchschnittsgehalt pro Jahr',
    XJM_META_DESCRIPTION_CATEGORY:
      '✔ Offene {category}-Stellen  ✔ Top-Arbeitgebern aus der Branche {category} ✔ Neues aus dem modernen Arbeitsleben',
    XJM_META_DESCRIPTION_CATEGORY_CITY:
      '✔ {city}er Jobs im Bereich {category} ✔ Die populärsten {city}er Arbeitgeber ✔ Die neuesten Trend der modernen Arbeitswelt',
    XJM_META_DESCRIPTION_CATEGORY_TERM:
      '✔ Aktuelle {term}-Jobs im Bereich {category}  ✔ Persönliche Job-Vorschläge für Dich ✔ Die beliebtesten Arbeitgeber in Deiner Nähe',
    XJM_META_DESCRIPTION_CITY_WITH_POSTINGS:
      '{postings} Jobs in {city} im XING Jobs-Netzwerk. Finde den Job, der zu Dir passt.',
    XJM_META_DESCRIPTION_COMPANY:
      '{term} Jobs im XING Jobs-Netzwerk ✓ Gehaltsspannen zu den Jobs erfahren ✓ Jetzt auf XING Deinen Traumjob finden!',
    XJM_META_DESCRIPTION_EMPLOYMENT_TYPE_CITY_WITH_POSTINGS:
      '{postings} {employmentType} Jobs in {city} im XING Jobs-Netzwerk. Finde den Job, der zu Dir passt.',
    XJM_META_DESCRIPTION_JOB_TYPE:
      '✔ Aktuelle Jobs ({job_type}) ✔ Andere  aktuelle Stellenangebote ✔ Die besten Arbeitgeber ✔ Interessante Infos rund um die moderne Arbeitswelt',
    XJM_META_DESCRIPTION_JOB_TYPE_CATEGORY:
      '✔ Aktuelle {category}-Jobs ({job_type}) ✔ Top-Arbeitgeber ✔ Wissenswertes zum Thema "Neue Arbeitswelt" ',
    XJM_META_DESCRIPTION_JOB_TYPE_TERM:
      '✔ {term}-Stellenangebote ({job_type}) ✔ Die beliebtesten Arbeitgeber ✔ Wissenswertes zur Arbeitswelt von heute',
    XJM_META_DESCRIPTION_JOB_TYPE_TERM_MINIJOBS:
      '✔ {term}-Stellenangebote (Mini-Jobs) ✔ Die beliebtesten Arbeitgeber ✔ Wissenswertes zur Arbeitswelt von heute',
    XJM_META_DESCRIPTION_SKILL:
      '{postings} {term} Jobs im XING Jobs-Netzwerk. Finde den Job, der zu Dir passt.',
    XJM_META_DESCRIPTION_SKILL_TYPE_CITY:
      '{postings} {term} Jobs in {city} im XING Jobs-Netzwerk.',
    XJM_META_DESCRIPTION_TERM_ANY_WITH_POSTINGS:
      '{postings} {term} Jobs im XING Jobs-Netzwerk. Finde den Job, der zu Dir passt.',
    XJM_META_DESCRIPTION_TERM_CITY_WITH_POSTINGS:
      '{postings} {role} Jobs in {city} im XING Jobs-Netzwerk. Finde den Job, der zu Dir passt.',
    XJM_META_DESCRIPTION_TERM_WITH_POSTINGS:
      '{postings} {role} Jobs im XING Jobs-Netzwerk. Finde den Job, der zu Dir passt.',
    XJM_META_TITLE_CATEGORY: '{category}-Jobs | XING: Jobs, die passen.',
    XJM_META_TITLE_CATEGORY_CITY:
      '{category}-Jobs in {city} | XING: Jobs, die passen.',
    XJM_META_TITLE_CATEGORY_TERM:
      '{term}-Jobs im Bereich {category} | XING: Jobs, die passen.',
    XJM_META_TITLE_CITY_WITH_DATE:
      'Aktuelle Jobs & Stellen in {city} - {month} {year}',
    XJM_META_TITLE_COMPANY: '{term} Jobs | XING Jobs-Netzwerk',
    XJM_META_TITLE_EMPLOYMENT_TYPE_CITY_WITH_DATE:
      '{employmentType} Jobs in {city} - {month} {year}',
    XJM_META_TITLE_JOB_TYPE:
      'Aktuelle Jobs ({job_type}) | XING: Jobs, die passen.',
    XJM_META_TITLE_JOB_TYPE_CATEGORY:
      '{category}-Jobs ({job_type}) | XING: Jobs, die passen.',
    XJM_META_TITLE_JOB_TYPE_TERM:
      '{term}-Jobs ({job_type}) | XING: Jobs, die passen.',
    XJM_META_TITLE_JOB_TYPE_TERM_MINIJOBS:
      '{term} Mini-Jobs | XING: Jobs, die passen.',
    XJM_META_TITLE_SKILL: 'Aktuelle {term} Jobs - {date}',
    XJM_META_TITLE_SKILL_TYPE_CITY:
      'Aktuelle {term} Jobs in {city} - {month} {year}',
    XJM_META_TITLE_TERM_ANY_WITH_DATE: 'Aktuelle {term} Jobs - {month} {year}',
    XJM_META_TITLE_TERM_CITY_WITH_POSTINGS:
      '{role} Jobs in {city} - {month} {year}',
    XJM_META_TITLE_TERM_WITH_DATE: '{role} Jobs & Stellen - {month} {year}',
    XJM_SEARCH_TITLE_CATEGORY_CITY: '{category}-Jobs in {city}',
    XJM_SEARCH_TITLE_CATEGORY_TERM: 'Finde {term}-Jobs im Bereich {category}',
    XJM_SEARCH_TITLE_EMPLOYMENT_TYPE_CITY: '{employmentType} Jobs in {city}',
    XJM_SEARCH_TITLE_EMPLOYMENT_TYPE_CITY_FREELANCER:
      'Freelancer Jobs in {city}',
    XJM_SEARCH_TITLE_EMPLOYMENT_TYPE_CITY_STUDENTEN: 'Studentenjobs in {city}',
    XJM_SEARCH_TITLE_JOB_TYPE_CATEGORY: '{category}-Jobs ({job_type})',
    XJM_SEARCH_TITLE_JOB_TYPE_CATEGORY_MINIJOBS: '{category} Minijobs',
    XJM_SEARCH_TITLE_JOB_TYPE_TERM: '{term}-Jobs ({job_type})',
    XJM_SEARCH_TITLE_SKILL_TYPE_CITY: '{term} Jobs in {city}',
    XJM_SEARCH_TITLE_TERM_CITY_WITH_DATE: '{role} Jobs in {city}',
    XJM_SEO_DIRECTORY_PAGINATION_H: 'Jobs nach Anfangsbuchstaben',
    XJM_SEO_JOB_ROLE: '{term} Jobs',
    XJM_SEO_RADIUS: 'im Umkreis von {radius} km',
    XJM_SEO_RELATED_JOB_TITLES_BY_SKILL: 'Weitere {skill} Jobs',
    XJM_SEO_RELATED_SKILLS_BY_JOB_ROLE: 'Beliebte Job-Suchen',
    XJM_SEO_TOP_CITIES_NEARBY_TITLE: 'Städte in der Nähe',
    XJM_SEO_TOP_CITIES_TITLE: 'Top-Städte',
    XJM_SEO_TOP_JOB_ROLE_LOCATIONS: 'Standorte für {role} Jobs',
    XJM_SEO_TOP_JOBS_TITLE: 'Top-Positionen',
    XJM_SEO_TOP_JOBS_TYPES_TITLE: 'Beschäftigungsarten',
    XJM_SEO_TOP_LOCATIONS_BY_SKILL: 'Top Orte für {skill} Jobs',
    XJM_SEO_XING_SERVICES_TITLE: 'XING Services',
    XJM_TEASER_LINKS_JOB_TYPE_TITLE: 'Jobs nach Beschäftigungsarten',
    XJM_TEASER_LINKS_JOBS: '-Jobs',
    XJM_TEASER_LINKS_JOBS_IN: '<strong>-Jobs</strong> in',
    XJM_TEASER_LINKS_TERM_TITLE: 'Meistgesuchte Job-Titel',
  },
};
